import { IAuthorizedRequestDTO } from '@/models/auth.model';
import { FileVariant, IFile } from '@/models/file.model';
import { Initiator } from '@/models/logs.model';

export enum PhotosEndpoints {
  PROPERTY_PHOTOS = '/properties',
}

export interface IPhoto {
  PK: string;
  SK: string;
  file_name: string;
  file_link: string;
  user_id: string;
  property_id: string;
  uploadedBy: Initiator;
  created: string;
  modified: string;
  is_selected: boolean;
  file_type: FileVariant;
}

// ============== DTO ==============

export interface IGetPropertyPhotosDTO extends IAuthorizedRequestDTO {
  with_selection?: boolean;
  property_id: string;
}

export interface IDeletePropertyPhotoDTO extends IAuthorizedRequestDTO {
  file_id: string;
  property_id: string;
}

export interface IUploadPropertyPhotosDTO extends IAuthorizedRequestDTO {
  property_id: string;
  files: IFile[];
  type: FileVariant;
}

// ============== Response ==============

export interface IPropertyPhotosResponse {
  photos_inside: IPhoto[];
  photos_outside: IPhoto[];
  floor_plan: IPhoto[];
}
